import { render } from "./view-invoice.vue?vue&type=template&id=801f542a"
import script from "./view-invoice.vue?vue&type=script&lang=js"
export * from "./view-invoice.vue?vue&type=script&lang=js"

import "./view-invoice.vue?vue&type=style&index=0&id=801f542a&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__